import React, { useRef } from "react";

const UploadFinancialStatement = ({
  id,
  closeUploadFinancialStatementOpen,
  isUploadFinancialStatementOpen,
  statementType,
  setStatementType,
  statementPassword,
  setStatementPassword,
  uploadedFile,
  setUploadedFile,
  handleUploadStatement,
}) => {
  const fileInputFront = useRef(null);

  const openFrontFilePicker = () => {
    fileInputFront.current.click();
  };

  const handlePhotoFileChange = (e) => {
    const file = e.target.files[0];
    setUploadedFile(file);
  };
  const isFormComplete =
    statementType && uploadedFile && statementPassword.trim() !== "";

  const handleCloseUploadFinancialStatementOpen = () => {
    setStatementPassword("");

    setUploadedFile(null);

    closeUploadFinancialStatementOpen();
  };

  const truncateFileName = (fileName) => {
    const maxLength = 12;
    const extensionIndex = fileName.lastIndexOf(".");
    const nameWithoutExtension = fileName.substring(0, extensionIndex);
    const truncatedName =
      nameWithoutExtension.length > maxLength
        ? `${nameWithoutExtension.substring(0, maxLength)}...`
        : nameWithoutExtension;
    return `${truncatedName}.${fileName.substring(extensionIndex + 1)}`;
  };

  return (
    <>
      <div
        id={id}
        className={`${
          isUploadFinancialStatementOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex fixed min-h-[80%] w-[60%]">
          <div className="relative flex bg-white shadow w-full mx-auto">
            <div className="flex flex-col justify-between w-full px-5">
              <div>
                <div className="flex items-center justify-end">
                  <button
                    onClick={handleCloseUploadFinancialStatementOpen}
                    type="button"
                    className="bg-transparent  rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    data-modal-toggle={id}
                  >
                    <svg
                      width="61"
                      height="43"
                      viewBox="0 0 61 43"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_13891_3896)">
                        <path
                          d="M32.84 28L30.7 24.9L28.9 28H25.2L28.88 22.3L25.1 16.84H28.94L31.08 19.92L32.88 16.84H36.58L32.84 22.46L36.68 28H32.84Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_13891_3896">
                          <rect width="61" height="43" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span className="sr-only">Close modal</span>
                  </button>
                </div>
                <div className="mt-3 mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Upload Financial Statement
                  </p>
                  <div className="text-[#000] mt-3 text-sm font-normal">
                    <p>
                      Submit a Bank or M-PESA statement covering a minimum
                      period of 6 months.
                    </p>
                  </div>
                </div>

                <div className="flex w-full items-center justify-center mt-8">
                  <div className="flex w-[60%] flex-col justify-center">
                    <label className="block mb-2 text-sm font-medium text-black">
                      Statement Type<span className="text-red-500">*</span>
                    </label>
                    <select
                      name="mode"
                      id="mode"
                      value={statementType}
                      onChange={(e) => setStatementType(e.target.value)}
                      className="w-full h-10 px-4 rounded-[4px] border-[1px] border-[#000]"
                    >
                      <option value="">-- Select statement type</option>
                      <option value="mpesa">M-PESA</option>
                      <option value="bank">BANK</option>
                    </select>
                  </div>
                </div>

                <div className="flex w-full items-center justify-center mt-10">
                  <div className="flex w-[60%] flex-col justify-center">
                    <div
                      onClick={openFrontFilePicker}
                      className="h-[170px] w-full border border-dashed border-gray-400 rounded-md flex flex-col items-center justify-center cursor-pointer text-center bg-gray-50"
                    >
                      <svg
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.5625 29.2069V12.9881L17.1938 17.3569L15.8663 16.0106L22.5 9.375L29.1356 16.0106L27.8081 17.3588L23.4375 12.9881V29.2069H21.5625ZM12.405 35.625C11.5413 35.625 10.8206 35.3363 10.2431 34.7588C9.66562 34.1812 9.37625 33.46 9.375 32.595V28.0519H11.25V32.595C11.25 32.8838 11.37 33.1488 11.61 33.39C11.85 33.6313 12.1144 33.7512 12.4031 33.75H32.5969C32.8844 33.75 33.1488 33.63 33.39 33.39C33.6313 33.15 33.7512 32.885 33.75 32.595V28.0519H35.625V32.595C35.625 33.4588 35.3363 34.1794 34.7588 34.7569C34.1812 35.3344 33.46 35.6238 32.595 35.625H12.405Z"
                          fill="black"
                        />
                      </svg>
                      <input
                        type="file"
                        ref={fileInputFront}
                        onChange={handlePhotoFileChange}
                        style={{ display: "none" }}
                      />

                      <p className="text-[#000000] text-[14px] text-center">
                        {!uploadedFile ? (
                          <>
                            Drag and Drop or{" "}
                            <span style={{ color: "#0187E8" }}>
                              Choose file
                            </span>{" "}
                            here
                          </>
                        ) : (
                          truncateFileName(uploadedFile.name)
                        )}
                      </p>

                      {uploadedFile && (
                        <p className="text-#074073B8 w-90% truncate text-16 text-center">
                          {uploadedFile.type} (
                          {(uploadedFile.size / 1024).toFixed(2)} KB)
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex w-full items-center justify-center mt-8">
                  <div className="flex w-[60%] flex-col">
                    <label className="block mb-2 text-sm font-medium text-black">
                      Statement Password<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="statementPasswordInput"
                      name="statementPassword"
                      placeholder="Enter the statement password"
                      value={statementPassword}
                      onChange={(e) => setStatementPassword(e.target.value)}
                      className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                    />
                  </div>
                </div>
              </div>
              <div className="flex items-end justify-end mt-10 mb-8">
                <button
                  onClick={handleUploadStatement}
                  type="submit"
                  className={`px-8 py-2 rounded-[6px] text-white font-medium cursor-pointer transition-colors duration-300 ${isFormComplete ? "bg-[#074073]" : "bg-[#D9D9D9] cursor-not-allowed"}`}
                >
                  Upload Statement
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadFinancialStatement;
